import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../shared/constants/routes";
import { signupUser } from "../api/authApi";
import { Colors } from "../../utils/Colors";

export default function SignupPage() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    full_name: "",
    email: "",
    password: "",
    role: "DOCTOR",
    doctor_id: "",
    phone: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const validate = () => {
    if (!form.full_name.trim()) {
      alert("Full name is required");
      return false;
    }

    if (!form.email.trim()) {
      alert("Email is required");
      return false;
    }

    if (!/\S+@\S+\.\S+/.test(form.email)) {
      alert("Please enter a valid email");
      return false;
    }

    if (!form.password.trim()) {
      alert("Password is required");
      return false;
    }

    if (form.password.length < 4) {
      alert("Password must be at least 4 characters");
      return false;
    }

    if (!form.role.trim()) {
      alert("Role is required");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      setLoading(true);

      const data = await signupUser(form);
      alert(data?.message || "Signup successful");

      navigate(ROUTES.AUTH_LOGIN, { replace: true });
    } catch (error) {
      const message =
        error?.response?.data?.email?.[0] ||
        error?.response?.data?.password?.[0] ||
        error?.response?.data?.full_name?.[0] ||
        error?.response?.data?.detail ||
        "Signup failed";

      alert(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: Colors.bg.app,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "460px",
          background: Colors.bg.paper,
          borderRadius: "20px",
          boxShadow: Colors.shadow.brand,
          border: `1px solid ${Colors.border.light}`,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "8px",
            background: Colors.brand.accentBar,
            width: "100%",
          }}
        />

        <div style={{ padding: "32px" }}>
          <h1
            style={{
              margin: 0,
              marginBottom: "8px",
              color: Colors.text.title,
              textAlign: "center",
              fontSize: "30px",
              fontWeight: "800",
            }}
          >
            Sign Up
          </h1>

          <p
            style={{
              marginTop: 0,
              marginBottom: "24px",
              textAlign: "center",
              color: Colors.text.muted,
              fontSize: "14px",
            }}
          >
            Create your account to continue
          </p>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "14px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "6px",
                  color: Colors.text.body,
                  fontWeight: "600",
                }}
              >
                Full Name
              </label>
              <input
                type="text"
                name="full_name"
                value={form.full_name}
                onChange={handleChange}
                placeholder="Enter full name"
                style={{
                  width: "100%",
                  padding: "12px 14px",
                  borderRadius: "12px",
                  border: `1px solid ${Colors.border.input}`,
                  outline: "none",
                  boxSizing: "border-box",
                  color: Colors.text.body,
                }}
              />
            </div>

            <div style={{ marginBottom: "14px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "6px",
                  color: Colors.text.body,
                  fontWeight: "600",
                }}
              >
                Email
              </label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter email"
                style={{
                  width: "100%",
                  padding: "12px 14px",
                  borderRadius: "12px",
                  border: `1px solid ${Colors.border.input}`,
                  outline: "none",
                  boxSizing: "border-box",
                  color: Colors.text.body,
                }}
              />
            </div>

            <div style={{ marginBottom: "14px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "6px",
                  color: Colors.text.body,
                  fontWeight: "600",
                }}
              >
                Password
              </label>
              <input
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Enter password"
                style={{
                  width: "100%",
                  padding: "12px 14px",
                  borderRadius: "12px",
                  border: `1px solid ${Colors.border.input}`,
                  outline: "none",
                  boxSizing: "border-box",
                  color: Colors.text.body,
                }}
              />
            </div>

            <div style={{ marginBottom: "14px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "6px",
                  color: Colors.text.body,
                  fontWeight: "600",
                }}
              >
                Role
              </label>
              <select
                name="role"
                value={form.role}
                onChange={handleChange}
                style={{
                  width: "100%",
                  padding: "12px 14px",
                  borderRadius: "12px",
                  border: `1px solid ${Colors.border.input}`,
                  outline: "none",
                  boxSizing: "border-box",
                  color: Colors.text.body,
                  background: Colors.bg.paper,
                }}
              >
                <option value="ADMIN">Admin</option>
                <option value="DOCTOR">Doctor</option>
                <option value="PATIENT">Patient</option>
              </select>
            </div>

            <div style={{ marginBottom: "14px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "6px",
                  color: Colors.text.body,
                  fontWeight: "600",
                }}
              >
                Doctor ID
              </label>
              <input
                type="text"
                name="doctor_id"
                value={form.doctor_id}
                onChange={handleChange}
                placeholder="Enter doctor id"
                style={{
                  width: "100%",
                  padding: "12px 14px",
                  borderRadius: "12px",
                  border: `1px solid ${Colors.border.input}`,
                  outline: "none",
                  boxSizing: "border-box",
                  color: Colors.text.body,
                }}
              />
            </div>

            <div style={{ marginBottom: "18px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "6px",
                  color: Colors.text.body,
                  fontWeight: "600",
                }}
              >
                Phone
              </label>
              <input
                type="text"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="Enter phone"
                style={{
                  width: "100%",
                  padding: "12px 14px",
                  borderRadius: "12px",
                  border: `1px solid ${Colors.border.input}`,
                  outline: "none",
                  boxSizing: "border-box",
                  color: Colors.text.body,
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: "13px",
                borderRadius: "12px",
                border: "none",
                background: Colors.brand.primary,
                color: "#fff",
                fontWeight: "700",
                fontSize: "15px",
                cursor: "pointer",
              }}
            >
              {loading ? "Creating..." : "Create Account"}
            </button>
          </form>

          <p
            style={{
              marginTop: "18px",
              textAlign: "center",
              color: Colors.text.muted,
              fontSize: "14px",
            }}
          >
            Already have an account?{" "}
            <span
              onClick={() => navigate(ROUTES.AUTH_LOGIN)}
              style={{
                color: Colors.brand.primary,
                fontWeight: "700",
                cursor: "pointer",
              }}
            >
              Login
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}